module.exports = __webpack_public_path__ + "static/media/rnb4culture.5953c26f.png";